
import { defineComponent, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getUser, isAuthenticated } from '@coderhouse/common'
import { useLocaleStore } from '@/store/locale.store'

export default defineComponent({
  components: {},
  setup() {
    const { t } = useI18n()
    const user = ref()

    onMounted(async () => {
      try {
        const auth = await isAuthenticated()
        user.value = await getUser()

        if (user.value.country) {
          const locale = useLocaleStore()
          await locale.fetchLocale(user.value.country)
        }
      } catch (error) {
        console.error(error)
      }
    })

    return { user, t }
  }
})
